import React from 'react';
import { Link } from 'react-router-dom';
import { FaAngleDoubleRight } from 'react-icons/fa';

import { PageTitle } from '../../../components';
import {therapyData} from '../../../constants';
import { images } from '../../../constants';
import './TherapySessions.css';

const TherapySessions = () => {
  return (
    <div className="therapy-sessions__wrapper">
      
      {/* --- Sekcja Hero (Banner) --- */}
      <div className='therapy-sessions__hero'>
        <div className='therapy-sessions__hero-content'> 
            <h2>Sesje Terapeutyczne</h2> 
            <h1 className="therapy-sessions__hero-heading"></h1>
        </div> 
        
        <div className='therapy-sessions__breadcrumbs'>
          <Link to='/' className="therapy-sessions__breadcrumbs-link">Strona Główna</Link>
          <FaAngleDoubleRight className='therapy-sessions__breadcrumbs-icon' />
          <span className='therapy-sessions__breadcrumbs-current'>Sesje Terapeutyczne</span>
        </div>
      </div>

      <div className="therapy-sessions__body">
        <div className="therapy-sessions__container">

          {/* --- GŁÓWNA TREŚĆ (Zajmująca całą szerokość) --- */}
          <main className="therapy-sessions__article">
            
            <header className="therapy-sessions__article-header">
                <h1 className="therapy-sessions__article-title">{therapyData.title}</h1>
                <h2 className="therapy-sessions__article-subtitle">{therapyData.subtitle}</h2>
            </header>

            {/* ZABEZPIECZONO: Dodano ?. przed map, aby uniknąć błędu jeśli intro nie istnieje */}
            <div className="therapy-sessions__intro">
                {therapyData.intro?.map((paragraph, index) => (
                   <p key={index} className="therapy-sessions__text-paragraph">
                       {paragraph}
                   </p>
                ))}
            </div>

            <hr className="therapy-sessions__divider" />

            <div className="therapy-sessions__content">
                {/* ZABEZPIECZONO: Dodano ?. przed map */}
                {therapyData.sections?.map((section, index) => (
                   <React.Fragment key={index}>
                       
                       {/* Tekst Sekcji */}
                       <section className="therapy-sessions__section">
                           <h3 className="therapy-sessions__section-heading">
                               {section.title}
                           </h3>
                           <p className="therapy-sessions__text-paragraph therapy-sessions__text-paragraph--justify">
                               {section.content}
                           </p>
                       </section>

                       {/* --- LOGIKA WSTAWIANIA ZDJĘĆ --- */}
                       
                       {/* Zdjęcie 1: Po pierwszej sekcji (index 0) */}
                       {index === 0 && images?.therapy_1 && (
                           <div className="therapy-sessions__image-wrapper">
                               <img 
                                   src={images.therapy_1} 
                                   alt="Bezpieczna przestrzeń do rozmowy" 
                                   className="therapy-sessions__article-image"
                               />
                               <span className="therapy-sessions__image-caption">Bezpieczna i dyskretna przestrzeń to fundament skutecznej terapii.</span>
                           </div>
                       )}

                       {/* Zdjęcie 2: Po trzeciej sekcji (index 2) */}
                       {index === 2 && images?.therapy_2 && (
                           <div className="therapy-sessions__image-wrapper">
                               <img 
                                   src={images.therapy_2} 
                                   alt="Rozmowa terapeutyczna z pacjentem" 
                                   className="therapy-sessions__article-image"
                               />
                           </div>
                       )}

                       {/* Zdjęcie 3: Po piątej sekcji (index 4) */}
                       {index === 4 && images?.therapy_3 && (
                           <div className="therapy-sessions__image-wrapper">
                               <img 
                                   src={images.therapy_3} 
                                   alt="Odzyskiwanie wewnętrznego spokoju" 
                                   className="therapy-sessions__article-image"
                               />
                           </div>
                       )}

                   </React.Fragment>
                ))}
            </div>

            <footer className="therapy-sessions__footer">
                <div className="therapy-sessions__bibliography">
                   <h4>Bibliografia i źródła</h4>
                   <ul>
                       {/* ZABEZPIECZONO: Dodano ?. przed map */}
                       {therapyData.bibliography?.map((item, index) => (
                           <li key={index}>{item}</li>
                       ))}
                   </ul>
                </div>
            </footer>

          </main>

        </div>
      </div>
    </div>
  );
}

export default TherapySessions;